var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.019,
    height: 26.836,
    viewBox: "0 0 45.019 26.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye_3_",
    "data-name": "eye (3)",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11791",
    "data-name": "Path 11791",
    d: "M22.51,98.725c-8.6,0-16.4,4.706-22.157,12.35a1.782,1.782,0,0,0,0,2.127c5.756,7.653,13.556,12.359,22.157,12.359s16.4-4.706,22.157-12.35a1.782,1.782,0,0,0,0-2.127C38.911,103.431,31.111,98.725,22.51,98.725Zm.617,22.866a9.469,9.469,0,1,1,8.832-8.832A9.474,9.474,0,0,1,23.127,121.591Zm-.285-4.365a5.1,5.1,0,1,1,4.761-4.761A5.09,5.09,0,0,1,22.841,117.226Z",
    fill: "#b4b0b0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show_password_icon.5ff13a0ea599a9b1e2625554fc10854a.svg";
export { ForwardRef as ReactComponent };